import React from 'react'
import styled from 'styled-components'
import { viewTranscationURL } from 'lottery/constants'
import {
  getPoolRewardText,
  getPoolBalanceText,
  getPoolTokenLogoURL,
  isUnnamed,
} from 'lottery/util'

const StyledTitle = styled.div`
  text-transform: capitalize;
`

const Styles = styled.div`
  padding: 1rem;
  width: 100%;
  table {
    border: none;
    margin: auto;
    color: #5b3926;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      border: none;
      border-bottom: 1px solid #f9cabf;
      padding: 0.5rem;
    }
  }
`
const StyledLink = styled.div`
  color: #5b3926;
  text-align: center;
`

const Table = ({ data }) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Pool Name</th>
          <th>Token Type</th>
          <th>Reward Amount</th>
          <th>View Transaction</th>
        </tr>
      </thead>
      <tbody>
        {data.map((pool, i) => {
          return (
            <tr key={i}>
              <td>
                <StyledTitle>{pool.name}</StyledTitle>
              </td>
              <td>
                <img src={getPoolTokenLogoURL(pool)} height="40" alt="dice" />
              </td>
              <td> {getPoolRewardText(pool)}</td>
              <td>
                <a
                  href={viewTranscationURL + pool.transactionHash}
                  target="_blank"
                >
                  <StyledLink>View</StyledLink>
                </a>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

const WinningTable = ({ data }) => {
  return (
    <Styles>
      <Table data={data} />
    </Styles>
  )
}

export default WinningTable
